var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 19.1668C4.91683 19.1668 0.833496 15.0835 0.833496 10.0002C0.833496 4.91683 4.91683 0.833496 10.0002 0.833496C15.0835 0.833496 19.1668 4.91683 19.1668 10.0002C19.1668 15.0835 15.0835 19.1668 10.0002 19.1668ZM10.0002 2.50016C5.8335 2.50016 2.50016 5.8335 2.50016 10.0002C2.50016 14.1668 5.8335 17.5002 10.0002 17.5002C14.1668 17.5002 17.5002 14.1668 17.5002 10.0002C17.5002 5.8335 14.1668 2.50016 10.0002 2.50016Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 10.8332H1.66683C1.16683 10.8332 0.833496 10.4998 0.833496 9.99984C0.833496 9.49984 1.16683 9.1665 1.66683 9.1665H18.3335C18.8335 9.1665 19.1668 9.49984 19.1668 9.99984C19.1668 10.4998 18.8335 10.8332 18.3335 10.8332Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 19.1668C9.75016 19.1668 9.5835 19.0835 9.41683 18.9168C7.16683 16.5002 5.91683 13.3335 5.8335 10.0002C5.91683 6.66683 7.16683 3.50016 9.41683 1.0835C9.5835 0.916829 9.75016 0.833496 10.0002 0.833496C10.2502 0.833496 10.4168 0.916829 10.5835 1.0835C12.8335 3.50016 14.0835 6.66683 14.1668 10.0002C14.0835 13.3335 12.8335 16.5002 10.5835 18.9168C10.4168 19.0835 10.2502 19.1668 10.0002 19.1668ZM10.0002 3.00016C8.41683 5.00016 7.5835 7.41683 7.50016 10.0002C7.5835 12.5002 8.41683 15.0002 10.0002 17.0002C11.5835 15.0002 12.4168 12.5002 12.5002 9.91683C12.4168 7.41683 11.5835 5.00016 10.0002 3.00016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlobe);
export default __webpack_public_path__ + "static/media/ic_globe.3d845b994bd7f3726545b04d1bd85321.svg";
export { ForwardRef as ReactComponent };